/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseTaxRate
 */
export interface GetConfig200ResponseTaxRate {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTaxRate
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTaxRate
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTaxRate
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTaxRate
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseTaxRate
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseTaxRate
     */
    delivery: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseTaxRate
     */
    takeaway: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseTaxRate
     */
    takeAway: number;
}

/**
 * Check if a given object implements the GetConfig200ResponseTaxRate interface.
 */
export function instanceOfGetConfig200ResponseTaxRate(value: object): value is GetConfig200ResponseTaxRate {
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('delivery' in value) || value['delivery'] === undefined) return false;
    if (!('takeaway' in value) || value['takeaway'] === undefined) return false;
    if (!('takeAway' in value) || value['takeAway'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseTaxRateFromJSON(json: any): GetConfig200ResponseTaxRate {
    return GetConfig200ResponseTaxRateFromJSONTyped(json, false);
}

export function GetConfig200ResponseTaxRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseTaxRate {
    if (json == null) {
        return json;
    }
    return {
        
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'category': json['category'],
        'label': json['label'],
        'value': json['value'],
        'delivery': json['delivery'],
        'takeaway': json['takeaway'],
        'takeAway': json['takeAway'],
    };
}

export function GetConfig200ResponseTaxRateToJSON(json: any): GetConfig200ResponseTaxRate {
    return GetConfig200ResponseTaxRateToJSONTyped(json, false);
}

export function GetConfig200ResponseTaxRateToJSONTyped(value?: GetConfig200ResponseTaxRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'category': value['category'],
        'label': value['label'],
        'value': value['value'],
        'delivery': value['delivery'],
        'takeaway': value['takeaway'],
        'takeAway': value['takeAway'],
    };
}

